const decodeHTMLEntities = (text) => {
    if (text === undefined || text === null) {
        return '';
    }

    // Primero reemplaza las entidades nombradas comunes
    const entities = [
        ['amp', '&'],
        ['apos', '\''],
        ['#x27', '\''],
        ['#x2F', '/'],
        ['#39', '\''],
        ['#47', '/'],
        ['lt', '<'],
        ['gt', '>'],
        ['nbsp', ' '],
        ['cent', '¢'],
        ['pound', '£'],
        ['yen', '¥'],
        ['euro', '€'],
        ['copyright', '©'],
        ['trademark', '®'],
        ['quot', '"']
    ];

    for (let i = 0; i < entities.length; ++i) {
        text = text.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);
    }

    // Reemplaza entidades numéricas decimales (&#10;)
    text = text.replace(/&#(\d+);/g, (match, dec) => {
        return String.fromCharCode(dec);
    });

    // Reemplaza entidades numéricas hexadecimales (&#xA;)
    text = text.replace(/&#x([A-Fa-f0-9]+);/g, (match, hex) => {
        return String.fromCharCode(parseInt(hex, 16));
    });

    return text;
};

export default decodeHTMLEntities;